import { TextField, Box } from "@mui/material";
import React from "react";
import { ReactComponent as MoreCalenderIcon } from "../../../assets/icons/calender-Icon.svg";
import styles from "./customDatePicker.module.scss";
import PropTypes from "prop-types";

const CustomDatepicker = (props) => {
  const {
    value,
    placeholderText = "",
    onChange,
    error,
    errorvalue,
    id,
  } = props;

  return (
    <Box
      className={`form-group ${styles.datepickerWrapper}`}
      onClick={props.openCalendar}
      data-testid="CustomDatepicker"
    >
      <Box className={styles.wrapper}>
        <TextField
          type="text"
          hiddenLabel
          size="small"
          variant="filled"
          className={`input-grp__box`}
          value={value}
          onClick={props.openCalendar}
          onChange={onChange}
          placeholder={placeholderText}
          id={`${id}-datepicker`}
        />
        <MoreCalenderIcon
          className="datepicker"
          onClick={props.openCalendar}
        ></MoreCalenderIcon>
        {error ? errorvalue : null}
      </Box>
    </Box>
  );
};

export default CustomDatepicker;
CustomDatepicker.propTypes = {
  value: PropTypes.any,
  placeholderText: PropTypes.any,
  onChange: PropTypes.any,
  error: PropTypes.any,
  errorvalue: PropTypes.any,
  id: PropTypes.any,
  openCalendar: PropTypes.any,
};
